"use client";

import { cn } from "@punchup/utils/cn";
import { Bug } from "lucide-react";
import { ComponentProps, useRef } from "react";

import { Button } from "../../shadcn/ui/button";
import { useSentryFeedback } from "./useSentryFeedback";

interface BugReportButtonProps extends Omit<
  ComponentProps<typeof Button>,
  "ref" | "children"
> {
  label?: string;
  iconClassName?: string;
  formTitle?: string;
}

export function BugReportButton({
  label,
  iconClassName,
  formTitle = "Report a Bug or Send Feedback",
  variant = "ghost",
  className,
  "aria-label": ariaLabel = "Report a bug or send feedback",
  ...rest
}: BugReportButtonProps) {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const isAvailable = useSentryFeedback(buttonRef, { formTitle });

  if (!isAvailable) return null;

  return (
    <Button
      ref={buttonRef}
      variant={variant}
      aria-label={ariaLabel}
      className={cn(
        "p-0 w-9 h-9 text-primary hover:text-primary hover:bg-transparent",
        className
      )}
      {...rest}
    >
      <Bug className={cn("h-5 w-5", label && "mr-2", iconClassName)} />
      {label}
    </Button>
  );
}
